<template>
  <BaseWrapper :loading="loading">
    <BaseCard title="Template Ucapan Ulang Tahun">
      <BaseInput inset label="Template" tag="textarea" placeholder="Selamat ulang tahun <<code>> di peringkat <<stage>>"
        rows="5" message="<<cod>" v-model="template" />
      <div class="flex justify-between mt-2">
        <p class="text-xs text-gray-500">
          Gunakan &lt;&lt;code&gt;&gt; untuk mereferensikan kode mitra usaha<br />
          Gunakan &lt;&lt;stage&gt;&gt; untuk mereferensikan peringkat mitra usaha<br />
        </p>
        <BaseButton @click="onSave">Simpan</BaseButton>
      </div>
    </BaseCard>
  </BaseWrapper>
</template>

<script>
import { requestMixin } from '../../../mixins/request/request';

export default {
  mixins: [requestMixin],
  data() {
    return {
      loading: true,
      template: null
    }
  },
  methods: {
    async loadTemplate() {
      this.loading = true

      const [res, err] = await this.request(`/api/v1/whatsapp-greet-templates/-actions/get-template`)

      if (!err) {
        this.template = res.content
      }

      this.loading = false
    },
    async onSave() {
      this.loading = true

      await this.request(`/api/v1/whatsapp-greet-templates/-actions/update`, {
        method: 'post',
        data: {
          content: this.template
        }
      })

      this.loading = false
    }
  },
  created() {
    this.loadTemplate()
  }
}
</script>